export enum ChemicalCategory {
    BUFFER ="BUFFER",
    OTHERS ="OTHERS"
    }
    